import foundation from '@rentivo/gatsby-core/src/containers/ThemeProvider/theme/foundation';
import components from '@rentivo/gatsby-core/src/containers/ThemeProvider/theme/components';

const theme = {
  ...foundation,
  components
};

export default theme;
